import { render, staticRenderFns } from "./user_stars.vue?vue&type=template&id=101312cb&scoped=true&"
import script from "./user_stars.vue?vue&type=script&lang=js&"
export * from "./user_stars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101312cb",
  null
  
)

export default component.exports